module.exports = "\n\t<transition name=\"h-tab\">\n\t\t<div class=\"o-tab\" v-show=\"this.currentTab\" :class=\"{'is-active':this.currentTab\t}\">\n\t\t\t<slot name=\"content\" :active=\"this.currentTab\"></slot>\n\t\t</div>\n\t</div>\n</template>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/scripts/components/tab.vue
// module id = 194
// module chunks = 17